import React from "react";
import PropTypes from "prop-types";

import Range from "../../shared/InputElements/Range";
import { useIntl } from 'react-intl';
import { useWidget } from "../../../context/widgetContext";

const SlideMonthsOfOwnership = ({
  id = "years-of-ownership-slider",
  ...rest
}) => {
  const intl = useIntl()
  const { userPrefs } = useWidget()
  const description = val =>
  val >= 12 ? val / 12 + intl.formatMessage({ id: "graph.years", defaultMessage: " years"}) : val / 12 + intl.formatMessage({ id: "graph.year", defaultMessage: " year"});

  return (
    <Range
      id={id}
      value={userPrefs.get("monthsOfOwnership")}
      rangeMin={12}
      rangeMax={120}
      rangeStep={12}
      description={description}
      handler={e => userPrefs.set({ monthsOfOwnership: e.target.value })}
      {...rest}
    />
  );
};

export default SlideMonthsOfOwnership;

SlideMonthsOfOwnership.propTypes = {
  id: PropTypes.string,
  description: PropTypes.func,
  label: PropTypes.string
};
